import { FC } from "react"
import { Check } from "lucide-react"
import { PrimaryBtn } from "../buttons"
import { PendingEmbedDomain } from "../../../types"

type Props = {
  domain: PendingEmbedDomain
  approve: (domain: PendingEmbedDomain) => Promise<boolean>
  /** Host currently being approved, from usePendingEmbedDomains. */
  approvingHost: string | null
  className?: string
}

/**
 * Approves a blocked domain in one click by saving the pattern the API already
 * worked out for it (`host` + `/*`) — no hand-typed wildcard, which is the
 * step that used to send these requests to support.
 */
const ApproveDomainButton: FC<Props> = ({
  domain,
  approve,
  approvingHost,
  className = ""
}) => {
  const isApproving = approvingHost === domain.host

  return (
    <PrimaryBtn
      size="sm"
      className={`shrink-0 ${className}`}
      onClick={() => approve(domain)}
      isLoading={isApproving}
      disabled={!!approvingHost}
      title={`Approve ${domain.suggested_pattern}`}
    >
      {!isApproving && <Check size={14} className="mr-1" />}
      Approve
    </PrimaryBtn>
  )
}

export default ApproveDomainButton
